/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');
import { createApp } from "vue";
import Swal from 'sweetalert2'
window.Swal = Swal;
import alert from './alert';
window.alert = alert;

import routing from "./main-routes";
import store from "./store";
import { useHead } from '@unhead/vue';
const app = createApp({
    created() {
        this.$store.commit("setBaseDomain", $('#base_domain').val());
        axios.get("/get-config").then(res => {
            // this.$store.commit("setBaseDomain", res.data.base_domain);
            this.$store.commit("setSubdomain", res.data.subdomain);
            this.$store.commit("setBookshelfName", res.data.bookshelf_name);
            this.$store.commit("setFavicon", res.data.favicon || null);
            this.$store.commit("setRecaptchaSiteKey", res.data.recaptcha_site_key);
            this.$store.commit("setMaxVersions", res.data.max_versions);
            this.$store.commit("setMaxHistories", res.data.max_histories);
            this.$store.commit("setMaxNotes", res.data.max_notes);
            this.$store.commit("setMaxNoteSize", res.data.max_note_size);
            this.$store.commit("setMaxArticleSize", res.data.max_article_size);
            this.$store.commit("setMaxGenre", res.data.max_genre);
            this.$store.commit("setMaxBackground", res.data.max_background);
            this.$store.commit("setMaxBackgroundEpisode", res.data.max_background_episode);
            this.$store.commit("setMaxHondana", res.data.max_hondana);
            this.$store.commit("setMaxBacklink", res.data.max_backlink);
            this.$store.commit("setMaxReplies", res.data.max_replies);
            this.$store.commit("setBookLimit", res.data.book_limit);
            this.$store.commit("setArticleLimit", res.data.article_limit);
            this.$store.commit("setR18", res.data.r18);
            this.$store.commit("setNovelCovers", res.data.novelCovers);
        }).catch(err => { alert.err(err) });
        this.$store.dispatch("readVersion");
        useHead({
            title: "貸し本棚 | Web小説家の隠れ家・小説投稿サイト",
            link: [ { rel: "canonical", href: location.origin + location.pathname, id: "canonical" } ]
        });
    },
});

import observer from "./observer";
app.config.globalProperties.$observer = observer;
import cookie from "./cookie";
app.config.globalProperties.$cookie = cookie;
app.config.globalProperties.useHead = useHead;
app.config.compilerOptions.whitespace = 'preserve';
app.use(routing);
app.use(store);

import VueDiff from 'vue-diff';
import 'vue-diff/dist/index.css';
app.use(VueDiff);

import VueLazyLoad from 'vue3-lazyload'
app.use(VueLazyLoad, {
    loading: 'https://dummyimage.com/500x705/dcdcdc/999.png&text=Now+loading',
    error: 'https://dummyimage.com/500x705/ccc/999.png&text=Not+Found',
    lifecycle: {
        loading: (el) => {},
        error: (el) => {
            console.error('error', el)
        },
        loaded: (el) => {}
    }
});

import dayjs from 'dayjs';
window.moment = dayjs;
require("dayjs/locale/ja");
moment.locale("ja");
const isSameOrBefore = require('dayjs/plugin/isSameOrBefore');
moment.extend(isSameOrBefore);
const isSameOrAfter = require('dayjs/plugin/isSameOrAfter');
moment.extend(isSameOrAfter);
const relativeTime = require('dayjs/plugin/relativeTime')
moment.extend(relativeTime);

import filters from "./filters";
app.config.globalProperties.$filters = filters;
app.config.globalProperties.$isPortal = true;

import Notifications from '@kyvg/vue3-notification'
app.use(Notifications);
import Paginate from "vuejs-paginate-next";
app.component("Paginate", Paginate);
import Editor from "components/Editor";
app.component("Editor", Editor);
import EditorStorage from "components/EditorStorage";
app.component("EditorStorage", EditorStorage);
import VLink from "components/VLink";
app.component("VLink", VLink);
import VueEasyLightbox from 'vue-easy-lightbox';
app.component("VueEasyLightbox", VueEasyLightbox);

import Loading from 'vue3-loading-overlay';
app.component("Loading", Loading);
app.component('Navigation', require('components/Navigation').default);
app.component('Foot', require('components/Foot').default);
app.component('R18', require('components/R18').default);


import { createHead } from "@vueuse/head"
app.use(createHead());

import VueAnalytics from 'vue3-analytics';
import axios from "axios";

if ($("#tracking_id").val()) {
    app.use(VueAnalytics, {
        id: $("#tracking_id").val(),
        routing
    });
}
app.mount("#main");


const style = "border: 3px solid #green; background-color: #fee; font-size: 1.2rem; font-weight: bold; color:darkgreen; padding:0.3rem 0.8rem; border-radius: .3rem; margin: .5em 0;";
console.info("%c貸し本棚へようこそ！ 作品の投稿をお待ちしています！", style);